import React from "react";

const EditIcon = (props) => {
  return (
    <svg
      {...props}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 3H4.16667C3.72464 3 3.30072 3.17559 2.98816 3.48816C2.67559 3.80072 2.5 4.22464 2.5 4.66667V16.3333C2.5 16.7754 2.67559 17.1993 2.98816 17.5118C3.30072 17.8244 3.72464 18 4.16667 18H15.8333C16.2754 18 16.6993 17.8244 17.0118 17.5118C17.3244 17.1993 17.5 16.7754 17.5 16.3333V10.5"
        stroke="#7E7E7E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3125 2.68744C15.644 2.35592 16.0937 2.16968 16.5625 2.16968C17.0313 2.16968 17.481 2.35592 17.8125 2.68744C18.144 3.01897 18.3303 3.4686 18.3303 3.93744C18.3303 4.40629 18.144 4.85592 17.8125 5.18744L10.3017 12.6991C10.1038 12.8968 9.85933 13.0415 9.59083 13.1199L7.19666 13.8199C7.12496 13.8409 7.04895 13.8421 6.97659 13.8236C6.90423 13.805 6.83819 13.7674 6.78537 13.7146C6.73255 13.6618 6.6949 13.5957 6.67637 13.5234C6.65783 13.451 6.65908 13.375 6.68 13.3033L7.38 10.9091C7.45877 10.6408 7.60378 10.3967 7.80166 10.1991L15.3125 2.68744Z"
        stroke="#7E7E7E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditIcon;
